import React, { useContext } from 'react';
import { FreightForwarderContext } from '../../../components/Session';

import { WithStyles, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
import { ChargeCode } from '../../../../types';

export const ChargeCodeToolTip = withStyles((theme) => ({
    tooltip: {
        fontSize: 16,
    },
}))((props: { chargeCode: ChargeCode } & WithStyles<any>) => {
    const { chargeCode, classes } = props;
    const { chargeCodes } = useContext(FreightForwarderContext);
    const chargeCodeLookup = chargeCodes ? chargeCodes.find((c) => c.code === chargeCode.code) : undefined;
    const toolTipText = chargeCodeLookup ? chargeCodeLookup.name : chargeCode.code;

    return (
        <Tooltip placement="top" title={toolTipText} classes={{ tooltip: classes.tooltip }}>
            <Box>{chargeCode.code}</Box>
        </Tooltip>
    );
});
